document.querySelectorAll('.product-btn').forEach(btn => {
  btn.addEventListener('click', function(e) {

    e.preventDefault();      // Stop link redirect
    e.stopPropagation();     // Stop bubbling

    let href = this.getAttribute('href');

    if (!href) return;

    // Remove #
    let cleanId = href.replace('#', '');

    console.log(cleanId);

    // Select section by ID
    let targetSection = document.querySelector('section[id="' + cleanId + '"]');

    if (targetSection) {
      console.log(targetSection);

      // Optional: Scroll to section smoothly
      targetSection.scrollIntoView({
        behavior: 'smooth'
      });
    }

  });
});